import { ImageModel } from "../imageModel";
import { DrugToFoodAlcoholInteractionModel } from "./drugToFoodAlcoholInteractionModel";
import { DrugToDiseaseInteractionAdminModel } from "./drugToDiseaseInteractionAdminModel";
import { DrugToDrugInteractionModel } from "./drugToDrugInteractionModel";
import { IngredientSideEffectModel } from "../sideEffect";
import { DosageContentModel } from "../dosage";
import { ATCCodeModel } from "../atcCode";
import { ActiveIngredientContentModel } from './activeIngredientContentModel';

export class ActiveIngredientAdminModel {
  public activeIngredientId: number;
  public activeIngredientName: string;
  public genericINNName: string;
  public commonChemicalName: string;
  public iupacChemicalName: string;
  public molecularFormula: string;
  public shortDescription: string;
  public description: string
  public image?: ImageModel;
  public atcCodeId: number;
  public drugToFoodAlcoholInteractions: Array<DrugToFoodAlcoholInteractionModel>;
  public drugToDiseaseInteractions: Array<DrugToDiseaseInteractionAdminModel>;
  public drugToDrugInteractions: Array<DrugToDrugInteractionModel>;
  public ingredientSideEffect: IngredientSideEffectModel;
  public dosageContent: DosageContentModel;
  public isWithSideEffects: boolean;
  public isWithDosageContent: boolean;
  public atcCode?: ATCCodeModel;
  public activeIngredientContent: Array<ActiveIngredientContentModel>;
}